import { useQuery } from 'react-query';
import request from '../helpers/request';

const ringListKey = ({
  fromDate,
  toDate,
  requestId,
  operatorId,
  companyId,
  phone,
}) => ['ringList', fromDate, toDate, requestId, operatorId, companyId, phone];

const getRingList = async (data) => {
  return await request.get(
    `/Phone/get_ring_list`,
    data,
    'При загрузке списка звонков произошла ошибка',
    { result: 'Error' }
  );
};

const useRingList = (queries, options) => {
  return useQuery(ringListKey(queries), () => getRingList(queries), options);
};

export default useRingList;
